module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesLuxury.911959a.jpg";